// extracted by mini-css-extract-plugin
export var card = "_8w-1";
export var container = "_8w-0";